export default __webpack_public_path__ + "img/141d8030e2c531d0d5b7e038100df356.jpeg";